import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DsIconModule } from '@bmw-ds/components';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-remedy-status-icon-renderer',
  standalone: true,
  imports: [CommonModule, DsIconModule],
  template: `
    <div class="remedy-list">
      <div class="remedy-item" *ngFor="let item of combinedItems">
        <!-- ← color driven per item using isRed flag -->
        <img
          *ngIf="item.icon === '11'"
          src="/assets/images/remedy_Y.png"
          class="remedy_icon"
        />
        <img
          *ngIf="item.icon === '12'"
          src="/assets/images/remedy_N.png"
          class="remedy_icon"
        />
        <span
          class="remedy-label"
          [style.color]="item.textColor === 'y' ? 'red' : 'black'"
        >
          {{ item.label }}
        </span>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .remedy-list {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin: 0;
        padding: 0;
        list-style: none;
      }
      .remedy-item {
        display: flex;
        flex-direction: row; /* ← icon and label in same row */
        flex-wrap: nowrap;
        gap: 4px;
        width: 100%;
      }
      .remedy_icon {
        margin-top: 4px;
        width: 18px;
        height: 18px;
        flex-shrink: 0; /* ← icon never shrinks */
      }
      .remedy-label {
        flex: 1; /* ← takes remaining space after icon */
        min-width: 0; /* ← allows text to shrink */
        white-space: normal;
        word-break: break-word;
        line-height: 1.8;
      }
    `,
  ],
})
export class RemedyStatusIconRenderer implements ICellRendererAngularComp {
  public value: any;
  public params!: ICellRendererParams;
  public showIcon: boolean = false;
  public label: string = '';
  public showLabel: boolean = false;
  public items: string[] = [];
  public itemsIcon: string[] = [];
  public combinedItems: { icon: string; textColor: string; label: string }[] =
    []; // ← ADD
  public remedyList: any[] = []; // ← ADD

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.setValues(params);
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.setValues(params);
    return true;
  }

  private setValues(params: ICellRendererParams): void {
    this.params = params;
    this.value = params.value;

    if (Array.isArray(this.value)) {
      // ✅ Build combinedItems — icon and label paired together per row
      this.combinedItems = this.value
        .map((item: any) => ({
          icon: String(item?.remedyStatusCode ?? '')
            .trim()
            .toLowerCase(), // '11' or '12'
          textColor: String(item?.defectStopSaleFlag ?? '')
            .trim()
            .toLowerCase(), // isRed logic
          label: String(item?.remedyStatus ?? '').trim(), // text after icon
        }))
        .filter(
          (i) => !!i.label && i.label !== 'null' && i.label !== 'undefined'
        );

      console.log(
        'RemedyStatusIconRenderer combinedItems:',
        this.combinedItems
      );

      this.label = '';
      this.showLabel = false;
      this.showIcon = false;
    } else {
      this.combinedItems = [];
      this.showIcon = this.isAffirmative(this.value);
      this.label = String(params?.value ?? '');
      this.showLabel = this.label.toLowerCase() !== 'y' && !!this.label;
    }
  }

  private isAffirmative(val: any): boolean {
    if (typeof val === 'boolean') return val;
    const s = String(val ?? '')
      .trim()
      .toLowerCase();
    if (!s) return false;
    if (s === 'no' || s === 'n' || s === 'false' || s === '0') return false;
    return (
      s === 'yes' ||
      s === 'y' ||
      s === 'true' ||
      s === '1' ||
      s.includes('avail') ||
      s === 'ok'
    );
  }
}
